(ns net.kestec.mhda-pilgrimage.public.application.widgets.onboard-action-block
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Card" :default Card]
    ["@mui/material/Chip" :default Chip]
    ["@mui/material/IconButton" :default IconButton]
    ["@mui/material/CardContent" :default CardContent]
    ["@mui/material/CardActions" :default CardActions]
    ["@mui/material/Button" :default Button]
    ["@mui/material/Table" :default Table]
    ["@mui/material/TableHead" :default TableHead]
    ["@mui/material/TableRow" :default TableRow]
    ["@mui/material/TableBody" :default TableBody]
    ["@mui/material/TableCell" :default TableCell]
    ["@mui/material/CircularProgress" :default CircularProgress]
    ["@mui/icons-material/ExpandMore" :default ExpandMoreIcon]
    ["@mui/icons-material/Warning" :default WarningIcon]
    ["@mui/icons-material/People" :default PeopleIcon]
    ["@mui/icons-material/DoNotDisturb" :default DoNotDisturbIcon]
    ["@mui/icons-material/Done" :default DoneIcon]
    ["@mui/icons-material/Edit" :default EditIcon]
    ["@mui/icons-material/DeleteForever" :default DeleteForeverIcon]
    [clojure.string :as str]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.lib-ui.are-you-sure-popup :as are-you-sure-word]
    [net.kestec.mhda-pilgrimage.public.applications.applications-events :as-alias applications-events]
    [net.kestec.mhda-pilgrimage.public.application.new-application-popup :as new-application-popup]
    [net.kestec.mhda-pilgrimage.public.application.application-form :as application-form]
    [re-frame.core :as rf]

    ))







(defn application-status [application]
  (cond
    (= (:place_state application) "OFF")
    [:> Typography {:sx {:fontSize "0.6rem" :textAlign "center" :color "darkred"}} [:> DoNotDisturbIcon {:sx {:color "darkred"}}]
     [:br]
     "Kein Platz"]

    (= (:place_state application) "FIX")
    [:> Typography {:sx {:fontSize "0.6rem" :textAlign "center" :color "darkgreen"}} [:> PeopleIcon {:sx {:color "darkgreen"}}]
     [:br]
     "Fixstarter"]

    (= (:place_state application) "WAIT")
    [:> Typography {:sx {:fontSize "0.6rem" :textAlign "center" :color "orange"}} [:> DoneIcon {:sx {:color "orange"}}]
     [:br]
     "Warteliste"]

    (application-form/steps-done? application)
    [:> Typography {:sx {:fontSize "0.6rem" :textAlign "center" :color "darkgreen"}} [:> DoneIcon {:sx {:color "darkgreen"}}]
     [:br]
     "Anmeldung"]
    :else
    [:> Typography {:sx {:fontSize "0.6rem" :textAlign "center" :color "var(--color-mhda-red)"}} [:> WarningIcon {:sx {:color "var(--color-mhda-red)"}}]
     [:br]
     "in Anmeldung"]))

(defn application-info [application]
  (cond
    (= (:place_state application) "OFF")
    [:<> "Leider können wir sie nicht mitnehmen."]

    (= (:place_state application) "FIX")
    [:<> "Glückwunsch ihnen wurde ein Teilnehmerplatz zugewiesen"]

    (= (:place_state application) "WAIT")
    [:<> "Sie befinden sich auf der Warteliste"]

    (application-form/steps-done? application)
    [:<> "Diese Anmeldung ist noch keine Garantie für eine Teilnahme! " "Bitte überweisen sie zeitgerecht den angegebenen Betrag."]

    :else
    [application-form/steps-missing-chips application]
    ))


(defn application-status-line [my-application]
  (let [pilgrimage-id @(rf/subscribe [::db/get ::db/me :pilgrimage-id])]

    [:> TableRow




     [:> TableCell
      (when (not (:application_checked my-application))
        [:> IconButton {:component "a" :href (str "/pilgrimage/" pilgrimage-id "/application/" (:id my-application) "/form")}
         [:> EditIcon]])

      (:shown_first_name my-application) " " (:shown_last_name my-application)]

     [:> TableCell ""]

     [:> TableCell
      [application-status my-application]
      ]
     [:> TableCell
      [application-info my-application]
      ]
     [:> TableCell
      (when (and (str/blank? (:place_state my-application)) (not (application-form/steps-done? my-application)))
        [:> IconButton {:onClick #(rf/dispatch [::are-you-sure-word/set-show-are-you-sure-popup my-application])}
         [:> DeleteForeverIcon]
         ])
      ]
     ]))


(defn application-status-block [my-applications]
  [:> Table
   [:> TableHead
    [:> TableRow
     [:> TableCell "Name"]
     [:> TableCell "Gruppe"]
     [:> TableCell "Status"]
     [:> TableCell ""]
     [:> TableCell ""]

     ]]
   (into [:> TableBody]
         (for [application my-applications]
           [application-status-line application]))
   ])


(defn onboard-action-block []
  (let [my-applications @(rf/subscribe [::db/get ::db/my-applications])]
    [:> Card
     [new-application-popup/new-application-popup]
     [are-you-sure-word/are-you-sure-word-popup
      (fn [a] [:span
               "Sind sie sicher, dass sie diese Anmeldung "
               [:br] "-- " [:span {:style {:color "darkblue"}} (:shown_first_name a) " " (:shown_last_name a)] " -- "
               [:br] "löschen wollen?" [:br] [:br]])
      (fn [a] (println "Lösche " a)
        (rf/dispatch [::applications-events/delete-application (:id a)])
        )]

     [:> CardContent
      ;[:pre (pr-str my-applications)]
      [:> Typography {:variant "h2"} "Mein Anmeldestatus"]
      [:> Typography {:variant "p"} "Bitte beachte, dass hier Aktualisierungen zu Anmeldestatus Gruppen sowie Abfahrtsort und Zeit im Laufe der Zeit ergänzt werden."]
      [:br]
      [:br]

      (if (nil? (:applicant-id my-applications))
        [:> CircularProgress {:size "20px"}]
        [application-status-block (:applications my-applications)])]


     [:> CardActions
      [:> Button {:variant "outlined"
                  :onClick #(rf/dispatch [::applications-events/set-show-new-application-popup true])
                  :color   "primary"
                  } (str "Eine " (when (and (:applications my-applications) (> (count (:applications my-applications)) 0)) "weitere ") "Person anmelden")]

      ]
     ]))